
















































import { Component, Vue } from 'vue-property-decorator';
import { RepositoryFactory } from '@/api/RepositoryFactory';

@Component({
  components: {
    ReportsNav: () => import('@/components/ReportsNav.component.vue'),
    ReportsPageHeader: () => import('@/components/ReportsPageHeader.component.vue'),
  },
})
export default class ReportsTechnicalView extends Vue {
  private reportsRepository = RepositoryFactory.get('reports');

  public chartTypes = ['Stacked Bar', 'Heatmap', 'Network Graph'];

  public metrics = [
    { label: 'Meist verwendete Actuator Types', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
    { label: 'Häufigste Kombinationen', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
    { label: 'Komponentenverteilung', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
    { label: 'Labels pro Hardwaretyp', value: '–', description: 'Platzhalter bis Datenquelle angebunden' },
  ];

  public async mounted() {
    try {
      const res = await this.reportsRepository.getTechnicalStats();
      const d = res.data;
      if (d.topActuatorTypes !== undefined) this.metrics[0].value = d.topActuatorTypes;
      if (d.topCombinations !== undefined) this.metrics[1].value = d.topCombinations;
      if (d.componentDistribution !== undefined) this.metrics[2].value = d.componentDistribution;
      if (d.labelsPerHardwareType !== undefined) this.metrics[3].value = d.labelsPerHardwareType;
    } catch {
      // keep defaults
    }
  }
}
